import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ProgramareSloturiBlocare, ProgramareSloturiBlocareUpdate } from './programari-blocare.interface';

@Injectable({
    providedIn: 'root'
})
export class ProgramariBlocareService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private storeProgramareSloturiBlocareUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.programariSloturiBlocare.storeProgramareSloturiBlocare;
    private updateProgramareSloturiBlocareUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.programariSloturiBlocare.updateProgramareSloturiBlocare;
    private deleteProgramareSloturiBlocareUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.programariSloturiBlocare.deleteProgramareSloturiBlocare;

    constructor(private http: HttpClient) { }

    addProgramareSloturiBlocare(programareSloturiBlocare: ProgramareSloturiBlocare) {
        return this.http.post(this.storeProgramareSloturiBlocareUrl, programareSloturiBlocare, this.httpOptions);
    }

    updateProgramareSloturiBlocare(programareSloturiBlocare: ProgramareSloturiBlocareUpdate) {
        return this.http.put(this.updateProgramareSloturiBlocareUrl, programareSloturiBlocare, this.httpOptions);
    }

    deleteProgramareSloturiBlocare(id: number) {
        return this.http.delete(this.deleteProgramareSloturiBlocareUrl + id);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
